<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="cigent-compliance-total-wrapper stats-component">
  <div class="cigent-compliance-title">
    <span class="draggable">{{'cigent-compliance.title' | translate}}</span>
  </div>
  <!-- The draggable class above was moved outside of the async below so gridstack
        will see it, otherwise the entire component is draggable -->
  <div *ngrxLet="cigentComplianceResult$ as cigentComplianceResult" class="cigent-compliance-data-wrapper">
      <h2 *ngIf="chooseCustomer; else haveCustomerData" class="title">{{'dashboard.select-a-customer' | translate}}</h2>
      <ng-template #haveCustomerData>
          <div class="cigent-compliance-chart-wrapper">
              <div #containerRef class="chart-area" [ngStyle]="{'height': graphStyle}">
                  <div *ngIf="hasData(cigentComplianceResult); else noData" class="chart">
                      <ngx-charts-pie-chart
                              [view]="[containerRef.offsetWidth, containerRef.offsetHeight]"
                              [results]="cigentComplianceResult?.chartData"
                              [legend]="showLegend"
                              [labels]="showLabels"
                              [doughnut]="isDoughnut"
                              [legendPosition]="legendPosition"
                              legendTitle=""
                              arcWidth=".34"
                              (select)="onClick($event)"
                              [scheme]="colorScheme">
                      </ngx-charts-pie-chart>
                  </div>
                  <ng-template #noData>
                      <div *ngIf="cigentComplianceResult" class="no-chart-data">
                          <span>{{'cigent-compliance.no-data' | translate}}</span>
                      </div>
                  </ng-template>
              </div>
              <div class="cigent-compliance-relative-changes-wrapper">
                  <div class="cigent-compliance-relative-changes-text">
                      <div>
                          <div class="sub-title">{{'cigent-compliance.subtitle' | translate}}</div>
                          <div>
                              <div class="data">{{'TOTAL' | translate}} - {{cigentComplianceResult?.response.total}}</div>
                              <div class="data">{{'COMPLIANT' | translate}} - {{cigentComplianceResult?.response.compliant}}</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </ng-template>
  </div>
</div>